import { useState } from "react";
import type { DiscoveryFiltersState } from "../types/discoveryFilter.types";

export function useDiscoveryFilters(): DiscoveryFiltersState {
  const [search, setSearch] = useState("");
  const [selectedQuick, setSelectedQuick] = useState("");
  const [selectedPlatforms, setSelectedPlatforms] = useState<string[]>([
    "instagram",
    "youtube",
  ]);
  const [location, setLocation] = useState("");
  const [category, setCategory] = useState("");
  const [language, setLanguage] = useState("");
  const [minFollowers, setMinFollowers] = useState(0);
  const [maxFollowers, setMaxFollowers] = useState(0);
  const [selectedTier, setSelectedTier] = useState("");
  const [minEngagement, setMinEngagement] = useState(0);
  const [maxEngagement, setMaxEngagement] = useState(0);
  const [selectedEngagementRanges, setSelectedEngagementRanges] = useState<
    string[]
  >([]);
  const [gender, setGender] = useState("");

  const clearAll = () => {
    setSearch("");
    setSelectedQuick("");
    setSelectedPlatforms(["instagram", "youtube"]);
    setLocation("");
    setCategory("");
    setLanguage("");
    setMinFollowers(0);
    setMaxFollowers(0);
    setSelectedTier("");
    setMinEngagement(0);
    setMaxEngagement(0);
    setSelectedEngagementRanges([]);
    setGender("");
  };

  return {
    search,
    setSearch,
    selectedQuick,
    setSelectedQuick,
    selectedPlatforms,
    setSelectedPlatforms,
    location,
    setLocation,
    category,
    setCategory,
    language,
    setLanguage,
    minFollowers,
    setMinFollowers,
    maxFollowers,
    setMaxFollowers,
    selectedTier,
    setSelectedTier,
    minEngagement,
    setMinEngagement,
    maxEngagement,
    setMaxEngagement,
    selectedEngagementRanges,
    setSelectedEngagementRanges,
    gender,
    setGender,
    clearAll,
  };
}
